import { useMemo } from 'react';
import { InsuranceResponse } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/api-service/v1/insurance_verification_api.pb';
import {
  InsuranceStatus,
  PayerDetail,
} from '@weave/schema-gen-ts/dist/schemas/insurance-verification/v1/insurance_verification_adapter.pb';
import { InsuranceDetailQueries } from '@frontend/api-insurance-detail';
import { prepareInsuranceDetailsForNonDental } from '../utils/prepare-data-utils/prepare-insurance-data';
import type { UndefinedOrNull, UseGetInsuranceDetailsDentalOrNonDentalResponse } from '../utils/types';

export const useGetNonDentalInsuranceDetails = (
  isNonDental: boolean,
  personId: string,
  locationId: string,
  insurancePersonDetails: UndefinedOrNull<InsuranceResponse>,
  payerListResponse: UndefinedOrNull<PayerDetail[]>
): UseGetInsuranceDetailsDentalOrNonDentalResponse | null => {
  //This Api is responsible for getting only non-dental coverage details of particular person
  const { data: insuranceVerificationDetails, isLoading } =
    InsuranceDetailQueries.useGetNonDentalInsuranceVerificationDetailsByPersonId({
      personId,
      locationId: locationId || '',
      options: {
        enabled: isNonDental && !!insurancePersonDetails && !!personId && !!locationId,
      },
    });
  const insuranceDetails = useMemo(() => {
    return prepareInsuranceDetailsForNonDental(
      insurancePersonDetails as InsuranceResponse,
      payerListResponse,
      isNonDental
    );
  }, [insurancePersonDetails, isNonDental, payerListResponse, insuranceVerificationDetails?.coverage]);

  const thirdPartyCoverage = insuranceVerificationDetails?.coverage?.thirdPartyCoverage;
  const hasActiveOrVerifiedInsurance =
    insuranceDetails?.thirdPartyCoverageStatus.toUpperCase() === InsuranceStatus.ACTIVE ||
    insuranceDetails?.thirdPartyCoverageStatus.toUpperCase() === InsuranceStatus.VERIFIED;

  return {
    isLoading,
    insuranceDetails,
    thirdPartyCoverage,
    hasActiveOrVerifiedInsurance,
  };
};
